document.addEventListener("DOMContentLoaded", function() {
    // Containers
    const canvasContainer = document.getElementById('image-canvas-container');
    const canvasInnerContainer = document.getElementById('canvas-inner-container');
    const dropdownContainer = document.querySelector('.custom-image-size-dropdown');
    const predefinedFiltersPreviews = document.querySelectorAll('.filter-preview');
    const orientationContainer = document.getElementById('orientation-container');
    // Inputs
    const imageUploadInput = document.getElementById('image-upload');
    const zoomRangeInput = document.getElementById('zoom-range-input');
    const rangeSliderInput = document.querySelectorAll('.range-slider');
    // --- Headings inputs
    const headingContainer = document.getElementById('headings-display');
    const headingInput = document.getElementById('heading-input');
    const subheadingInput = document.getElementById('subheading-input');
    const headingText = document.getElementById('heading-text');
    const subheadingText = document.getElementById('subheading-text');
    // --- Filters Inputs
    const filtersForm = document.getElementById('filters-form');
    const brightnessInput = document.getElementById('brightness-range-input');
    const contrastInput = document.getElementById('contrast-range-input');
    const blurInput = document.getElementById('sharpness-range-input');
    const saturationInput = document.getElementById('saturation-range-input');
    const hueInput = document.getElementById('shade-range-input');
    // Action Buttons
    const mirrorButton = document.getElementById('mirror-button');
    const rotateButton = document.getElementById('rotate-button');
    const resetFiltersButton = document.getElementById('reset-button');
    const sizeSelector = document.querySelector('.custom-image-size-dropdown .custom-dropdown-items');
    const submitButton = document.getElementById('submit-button');
    // Radios
    const orientationRadioButtons = document.querySelectorAll('input[name="orientation"]');
    const fontRadioButtons = document.querySelectorAll('input[name="font"]');
    const borderColorRadioButtons = document.querySelectorAll('input[name="color"]');
    // Text containers
    const uploadImageLabelText = document.getElementById('image-upload-label').querySelector('span');

    const sizeRequirements = {
        '21x15 (210 x 148 mm)': { width: 210, height: 148 },
        '30x21 (297 x 210 mm)': { width: 297, height: 210 },
        '30x30 (300 x 300 mm)': { width: 300, height: 300 },
        '42x42 (420 x 420 mm)': { width: 420, height: 420 },
        '42x32 (420 x 297 mm)': { width: 420, height: 297 },
        '60x60 (600 x 600 mm)': { width: 600, height: 600 },
        '60x42 (594 x 420 mm)': { width: 594, height: 420 },
        '70x70 (700 x 700 mm)': { width: 700, height: 700 },
        '90x90 (900 x 900 mm)': { width: 900, height: 900 },
        '84x60 (841 x 594 mm)': { width: 841, height: 594 },
        '119x84 (1188 x 841 mm)': { width: 1188, height: 841 },
        '30x20 (300 x 200 mm)': { width: 300, height: 300 },
        '40x30 (400 x 300 mm)': { width: 400, height: 300 },
        '60x40 (600 x 400 mm)': { width: 600, height: 400 },
        '30x30 (300 x 300 mm)': { width: 300, height: 300 },
        '40x40 (400 x 400 mm)': { width: 400, height: 400 },
        '60x60 (600 x 600 mm)': { width: 600, height: 600 },
        '70x70 (700 x 700 mm)': { width: 700, height: 700 },
        '80x60 (800 x 600 mm)': { width: 800, height: 600 },
        '100x70 (1000 x 700 mm)': { width: 1000, height: 700 },
        '120x80 (1170 x 770 mm)': { width: 1170, height: 770 },
    };

    let stageWidth;
    let stageHeight = window.isMobileScreen() ? 465 : 670;
    let stage, layer;

    let konvaImg;
    let currentUploadedImage;
    let imageWidth, imageHeight;
    let originalWidth, originalHeight;
    let uploadedImageOrientation;
    let imgSrc;
    let imgAspectRatio;
    let originalImageFile = null;

    let rotationAngle = 0;
    let isMirrored = false;
    let selectedOrientation = 'portrait';
    let selectedSize = '21x15 (210 x 148 mm)';
    let lastValidSize = sizeSelector.value;

    // Global filters
    let currentBrightness = 100;
    let currentContrast = 0;
    let currentBlur = 0;
    let currentSaturation = 100;
    let currentHue = 0;

    let selectedFont = 'Arial';
    let currentTextColor = 'black';

    // Bottom text space
    let headingSpaceHeight = window.isMobileScreen() ? 10 : 15;

    // Show loading screen
    window.showLoadingSpinner('custom-image-upload-loader', true);

    // Create script tag and inject Konva CDN
    const konvaCDNScript = document.createElement("script");
    konvaCDNScript.src = "https://cdn.jsdelivr.net/npm/konva@8.4.3/konva.min.js";

    // Remove loading screen and init Konva
    konvaCDNScript.onload = function() {
        setTimeout(() => {
            window.showLoadingSpinner('custom-image-upload-loader', false);
        }, 500);

        initKonva();
    };
    konvaCDNScript.onerror = function() {
        console.error("Failed to load Konva JS.");
    };
    document.head.appendChild(konvaCDNScript);

    // Init Konva stage & layer
    function initKonva() {
        stage = new Konva.Stage({
            container: 'canvas-inner-container',
            width: stageWidth,
            height: stageHeight
        });
        layer = new Konva.Layer();
        stage.add(layer);
    }

    imageUploadInput.type = 'file';
    imageUploadInput.accept = 'image/*';

    // Event listeners when the image is uploaded/changed
    imageUploadInput.addEventListener('change', function(e) {
        const file = e.target.files[0];

        if (!file) return;

        originalImageFile = file;
        // Validate file type
        if (!/\.(jpg|jpeg|png|webp)$/i.test(file.name)) {
            showAlert('Unsupported file type', 'Unsupported file type. Please select a supported image type.', true);
            disableControls(true);
            resetEverything();
            resetUploadInput();
            displayHeadingContainer(false);
            disableControls(true);
            setCursor('default');
            return;
        }

        window.showLoadingSpinner('custom-image-upload-loader', true, 500);

        const reader = new FileReader();
        reader.onload = function(event) {
            const originalImg = new Image();
            originalImg.onload = function() {

                // Preview image width & scale factor
                const previewImageMaxWidth = 1920;
                const scale = Math.min(1, previewImageMaxWidth / originalImg.width);

                // Create canvas for preview image
                const previewImageCanvas = document.createElement('canvas');
                previewImageCanvas.width = originalImg.width * scale;
                previewImageCanvas.height = originalImg.height * scale;

                // Draw the original image on the canvas
                const ctx = previewImageCanvas.getContext('2d');
                ctx.drawImage(originalImg, 0, 0, previewImageCanvas.width, previewImageCanvas.height);

                const previewDataURL = previewImageCanvas.toDataURL('image/png');

                // Use low resolution image for preview
                const previewImage = new Image();
                previewImage.onload = function() {
                    currentUploadedImage = previewImage;
                    imgSrc = previewDataURL;

                    selectedSize = '21x15 (210 x 148 mm)';
                    selectedOrientation = 'portrait';
                    orientationContainer.style.display = 'block';
                    resetEverything();
                    checkUploadedImageOrientation();

                    if (!validateImageSizeCompatibility(selectedSize, true)) {
                        currentUploadedImage = null;
                        imgSrc = null;
                        setUploadInputText('Datei auswählen');
                        resetSizeDropdown('21x15 (210 x 148 mm)');
                        resetKonvaImage();
                        setCursor('default');
                        return;
                    }

                    resizeImage('21x15');
                    displayImage();
                    applyFiltersToPredefinedFiltersPreviews();
                    updatePredefinedFiltersPreviews();
                    updateText();
                    setUploadInputText(file.name);
                };

                previewImage.src = previewDataURL;
            };

            originalImg.src = event.target.result;
        };
        reader.readAsDataURL(file);
    });

    function displayImage() {
        // Remove previous image
        resetKonvaImage();
        resetMiroring();
        resetZoom();
        resetRotationAngel();
        setCursor('grab');

        originalWidth = currentUploadedImage.width;
        originalHeight = currentUploadedImage.height;

        // Get the stage dimensions
        const stageWidth = stage.width();
        const stageHeight = stage.height();

        // Calculate image scale factor
        const scale = Math.max(stageWidth / originalWidth, stageHeight / originalHeight);

        // Calculate the new dimensions based on the scale
        imageWidth = originalWidth * scale;
        imageHeight = originalHeight * scale;

        // Create and center the Konva image
        konvaImg = new Konva.Image({
            image: currentUploadedImage,
            x: (stageWidth - imageWidth) / 2,
            y: (stageHeight - imageHeight) / 2,
            width: imageWidth,
            height: imageHeight,
            draggable: true,
        });

        // Update drag boundaries when the image is moved
        konvaImg.on('dragmove', updateDraggableArea);
        layer.add(konvaImg);
        layer.draw();
        disableControls(false);
    }

    // Make image draggable within the stage
    function updateDraggableArea() {
        if (!konvaImg) return;

        // Create box around the image
        const box = konvaImg.getClientRect();
        let newX;
        let newY;

        // Define & calculate new bound for the image
        let minX = stage.width() - box.width;
        let maxX = 0;
        let minY = stage.height() - box.height;
        let maxY = 0;

        if (rotationAngle === 0) {
            if (isMirrored) {
                minX = -(box.width - stage.width());
                maxX = 0;
            }

            newX = Math.min(Math.max(konvaImg.x(), minX), maxX);
            newY = Math.min(Math.max(konvaImg.y(), minY), maxY);

        } else {
            newX = Math.min(Math.max(box.x, minX), maxX) + box.width / 2;
            newY = Math.min(Math.max(box.y, minY), maxY) + box.height / 2;
        }

        konvaImg.x(newX);
        konvaImg.y(newY);
        layer.batchDraw();
    }

    function updateKonvaStage(width, height) {
        // switch height & width when it's Portrait
        if (selectedOrientation === 'portrait') {
            [width, height] = [height, width];
        }
        const aspectRatio = width / height;
        const stageWidth = canvasInnerContainer.offsetWidth;
        const stageHeight = stageWidth / aspectRatio;
        stage.width(stageWidth);
        stage.height(stageHeight);
        layer.draw();
    }

    function resizeImage(size) {
        if (!konvaImg) return;

        // Get the size (21x15)
        selectedSize = size.split(' ')[0];
        let { width, height } = getSizeDimensionsBasedOnSelectedSize();

        selectedOrientation = document.querySelector('input[name="orientation"]:checked').value;

        // Check if selected size is Quadratic
        const isQuadratic = width === height;

        updateKonvaStage(width, height);

        orientationContainer.style.display = isQuadratic ? 'none' : 'block';

        // Changed width & height based on orientation
        konvaImg.width(imageWidth);
        konvaImg.height(imageHeight);

        resetZoom();
        resetMiroring();
        resetRotationAngel();
        konvaImg.rotation(0);
        konvaImg.scaleX(1);
        konvaImg.scaleY(1);
        konvaImg.offsetX(0);
        konvaImg.offsetY(0);
        konvaImg.x(0);
        konvaImg.y(0);

        layer.draw();
    }

    // Validate size compatibility with the image dimension 
    function validateImageSizeCompatibility(size, reset) {
        selectedSize = size.split(' ')[0];

        const uploadedImageLongestEdge = Math.max(currentUploadedImage.width, currentUploadedImage.height);
        const requiredLongestEdge = minPixelsRequired(selectedSize);

        if (uploadedImageLongestEdge < requiredLongestEdge) {
            showAlert(
                'Image Resolution Too Low',
                `The uploaded image's largest side must be at least ${requiredLongestEdge}px for this print size.`,
            );

            if (reset) {
                resetEverything();
                resetUploadInput();
                displayHeadingContainer(false);
                disableControls(true);
                setCursor('default');
            }
            return false;
        }
        return true;
    }

    // Function to apply image filters
    function applyFilters() {
        if (!konvaImg) return;

        // Clear & re-cache at 3× to preserve detail
        konvaImg.clearCache();
        konvaImg.cache({ pixelRatio: 3 });

        // Get konva filters
        konvaImg.filters([
            Konva.Filters.Brighten,
            Konva.Filters.Contrast,
            Konva.Filters.Blur,
            Konva.Filters.HSL,
        ]);

        // Apply filters from user input
        konvaImg.brightness((currentBrightness - 100) / 100);
        konvaImg.contrast(currentContrast);
        konvaImg.blurRadius(currentBlur);
        konvaImg.saturation((currentSaturation - 100) / 100);
        konvaImg.hue(currentHue);

        layer.batchDraw();
    }

    // Function to handle image rotation
    function rotateImage() {
        if (!konvaImg) return;

        // Reset zoom
        resetZoom();

        rotationAngle = (rotationAngle + 90) % 360;
        konvaImg.rotation(rotationAngle);
        let { width, height } = getSizeDimensionsBasedOnSelectedSize();

        // Update image dimension & position based on the rotation and mirroring status
        if (rotationAngle === 0 || rotationAngle === 180) {
            konvaImg.width(imageWidth);
            konvaImg.height(imageHeight);
            konvaImg.offsetX(0);
            konvaImg.offsetY(0);
            if (isMirrored) {
                konvaImg.offsetX(konvaImg.width());
            }
            if (width && height) {
                updateKonvaStage(width, height);
            }

            if (rotationAngle) {
                konvaImg.offsetX(konvaImg.width() / 2);
                konvaImg.offsetY(konvaImg.height() / 2);
            }
        } else if (rotationAngle === 90 || rotationAngle === 270) {
            konvaImg.width(imageWidth);
            konvaImg.height(imageHeight);
            konvaImg.offsetX(konvaImg.width() / 2);
            konvaImg.offsetY(konvaImg.height() / 2);

            // If the uploaded image was portrait, adapt the stage to the rotated (landscape) crop
            if (selectedOrientation === 'portrait') {
                if (width && height) {
                    [width, height] = [height, width];
                    updateKonvaStage(width, height);
                }
            }
        }

        // re-center the image
        konvaImg.x(stage.width() / 2);
        konvaImg.y(stage.height() / 2);

        updateDraggableArea();
        konvaImg.clearCache();
        konvaImg.cache({ pixelRatio: 3 });
        layer.batchDraw();
    }

    function toggleMirror() {
        if (!konvaImg) return;

        // Reset image to its original scale and reset zoom
        konvaImg.scaleY(1);
        resetZoom();

        // Toggle mirroring state
        isMirrored = !isMirrored;
        konvaImg.scaleX(isMirrored ? -1 : 1);

        // Calculate the offsetX based on current rotation and mirroring stage
        if (rotationAngle === 90 || rotationAngle === 270 || rotationAngle === 180) {
            konvaImg.offsetX(konvaImg.width() / 2);
        } else {
            konvaImg.offsetX(isMirrored ? konvaImg.width() : 0);
        }

        // Centralize the image based on rotation
        if (rotationAngle === 0 && isMirrored) {
            konvaImg.x(stage.width() - konvaImg.width());
        } else {
            // Center image for rotated states or non-mirrored state
            konvaImg.x(stage.width() / 2 - konvaImg.width() / 2);
            konvaImg.y(stage.height() / 2 - konvaImg.height() / 2);
        }

        updateDraggableArea();
        layer.batchDraw();
    }

    // Adjust stage dimensions based on selected orientation
    function updateStageOrientation() {
        // Reset image
        resetZoom();
        resetRotationAngel();
        resetMiroring();

        selectedOrientation = document.querySelector('input[name="orientation"]:checked').value;
        // Get dimension & check if it's quadratic
        const matchingKey = Object.keys(sizeRequirements).find(key =>
            key.startsWith(selectedSize)
        );
        let { width, height } = sizeRequirements[matchingKey];

        // Changes width and height based on Image dimension
        updateKonvaStage(width, height);

        // Update the image display with new stage dimensions
        layer.draw();
        stage.draw();
        updateImageSize();
    }

    // Update image size depending on if the headings is visible or not
    function updateImageSize() {
        if (!konvaImg) return;

        updateText();
        layer.draw();
    }

    // Zoom in & out of the image
    function applyZoom() {
        const zoomLevel = parseFloat(zoomRangeInput.value);
        if (!konvaImg) return;

        // Get the visible part of the image on stage
        const visiblePartX = (stage.width() / 2 - konvaImg.x()) / konvaImg.scaleX();
        const visiblePartY = (stage.height() / 2 - konvaImg.y()) / konvaImg.scaleY();

        // Zoom in & out
        konvaImg.scaleX(isMirrored ? -zoomLevel : zoomLevel);
        konvaImg.scaleY(zoomLevel);

        // Adjust position to keep the visible section centered
        konvaImg.x(stage.width() / 2 - visiblePartX * konvaImg.scaleX());
        konvaImg.y(stage.height() / 2 - visiblePartY * konvaImg.scaleY());

        updateDraggableArea();
        layer.batchDraw();
    }

    // Predefined filters container 
    function updatePredefinedFiltersPreviews() {
        predefinedFiltersPreviews.forEach((preview) => {
            // Checks if a div exits for the preview, if not then inset it
            let placeholder = preview.previousElementSibling;
            if (!placeholder || placeholder.nodeName !== 'DIV') {
                placeholder = document.createElement('div');
                preview.parentNode.insertBefore(placeholder, preview);
            }

            if (!konvaImg) {
                // when the image is not loaded, add styles to the div
                placeholder.style.width = '100%';
                placeholder.style.height = '4.375rem';
                placeholder.style.backgroundColor = '#F4F4F4';
                placeholder.style.display = 'block';
                preview.style.display = 'none';
            } else {
                if (preview) {
                    filterSplide.refresh();
                }

                placeholder.style.backgroundColor = 'transparent';
                // else remove styles & show the image
                placeholder.style.display = 'none';
                preview.style.display = 'block';
            }
        });
    }
    updatePredefinedFiltersPreviews();

    // Apply filters to the preview containers 
    function applyFiltersToPredefinedFiltersPreviews() {
        predefinedFiltersPreviews.forEach(preview => {
            // Set fixed dimensions for the preview images

            preview.onload = () => {
                // Fetch filter values and apply them
                const brightness = parseInt(preview.parentElement.getAttribute('data-brightness'), 10) || 100;
                const contrast = parseInt(preview.parentElement.getAttribute('data-contrast'), 10) || 100;
                const hue = parseInt(preview.parentElement.getAttribute('data-hue'), 10) || 0;
                const saturation = parseInt(preview.parentElement.getAttribute('data-saturation'), 10) || 100;

                // Apply the CSS filter directly to the image element
                preview.style.filter = `brightness(${brightness}%) contrast(${contrast}%) hue-rotate(${hue}deg) saturate(${saturation}%)`;
            };
            preview.src = imgSrc;
        });
    }

    // Apply the Predefined filters to the image
    function applySpecificFilterToPredefinedFiltersImage(brightness, contrast, hue, saturation) {
        if (!konvaImg) return;

        konvaImg.clearCache();
        konvaImg.cache({ pixelRatio: 3 });
        konvaImg.filters([Konva.Filters.Brighten, Konva.Filters.Contrast, Konva.Filters.HSL]);
        konvaImg.brightness((brightness - 100) / 100);
        konvaImg.contrast((contrast - 100) / 100);
        konvaImg.hue(hue);
        konvaImg.contrast((saturation - 100) / 100);

        brightnessInput.value = brightness;
        contrastInput.value = contrast;
        hueInput.value = hue;
        saturationInput.value = saturation;

        setRangeInputTrackFill(brightnessInput, brightness);
        setRangeInputTrackFill(contrastInput, contrast);
        setRangeInputTrackFill(hueInput, hue);
        setRangeInputTrackFill(saturationInput, saturation);
        // Redraw the layer to apply filters
        layer.batchDraw();
    }

    function updateText() {
        headingText.textContent = headingInput.value;
        subheadingText.textContent = subheadingInput.value;

        // Apply styles dynamically based on the selected font
        headingText.style.fontFamily = selectedFont;
        subheadingText.style.fontFamily = selectedFont;
        headingText.style.fontWeight = '600';
        subheadingText.style.fontWeight = 'normal';

        // Set custom styles for heading and subheading
        if (selectedOrientation === 'landscape') {
            headingText.style.fontSize = '14px';
            subheadingText.style.fontSize = '11px';
        } else {
            headingText.style.fontSize = '16px';
            subheadingText.style.fontSize = '12px';
        }

        // Update visibility based on content
        if (headingInput.value || subheadingInput.value) {
            headingContainer.style.marginTop = `${headingSpaceHeight}px`;
            displayHeadingContainer(true);
        } else {
            displayHeadingContainer(false);
        }
    }

    // Reset all filters
    function resetFilters() {
        if (konvaImg) {
            konvaImg.filters([]);
            konvaImg.brightness(0);
            konvaImg.contrast(0);
            konvaImg.blurRadius(0);
            konvaImg.saturation(0);
            konvaImg.hue(0);
            konvaImg.clearCache();
            konvaImg.cache({ pixelRatio: 3 });
            layer.draw();
        }

        // Reset all filter values
        currentBrightness = 100;
        currentContrast = 0;
        currentBlur = 0;
        currentSaturation = 100;
        currentHue = 0;

        // Reset range inputs
        brightnessInput.value = 100;
        contrastInput.value = 0;
        blurInput.value = 0;
        saturationInput.value = 100;
        hueInput.value = 0;

        setRangeInputTrackFill(brightnessInput, 100);
        setRangeInputTrackFill(contrastInput, 0);
        setRangeInputTrackFill(blurInput, 0);
        setRangeInputTrackFill(saturationInput, 100);
        setRangeInputTrackFill(hueInput, 0);

        filtersForm.reset();
    }

    // Reset zoom
    function resetZoom() {
        zoomRangeInput.value = 1;
        setRangeInputTrackFill(zoomRangeInput, 1);
        applyZoom();
    }

    function resetMiroring() {
        isMirrored = false;
    }

    function resetRotationAngel() {
        rotationAngle = 0;
    }

    function resetOrientation() {
        // Reset selected options
        orientationRadioButtons.forEach(input => {
            if (input.value === 'portrait') {
                input.checked = true;
            } else {
                input.checked = false;
            }
        });

        // Reset size & orientation
        selectedOrientation = 'portrait';
    }

    function resetKonvaImage() {
        if (konvaImg) {
            konvaImg.destroy();
            konvaImg = null;
        }
    }

    function resetBorderColor() {
        canvasContainer.style.borderColor = '#FFF';
        canvasContainer.style.backgroundColor = '#FFF';
        stage.getContainer().style.backgroundColor = '#FFF';
        headingText.style.color = 'black';
        subheadingText.style.color = 'black';
        // set first button as active 'white'
        borderColorRadioButtons[0].checked = true;
    }

    function resetFontFamily() {
        selectedFont = 'Arial';
        fontRadioButtons[0].checked = true;
    }

    function resetUploadInput() {
        imageUploadInput.value = "";
        setUploadInputText('Datei auswählen');
    }

    function displayHeadingContainer(show) {
        if (show) {
            headingContainer.style.display = 'block';
        } else {
            headingContainer.style.display = 'none';
        }
    }

    function resetSizeDropdown(resetSize) {
        if (!dropdownContainer) return;

        // Get the dropdown button and the list of items.
        const dropdownButton = dropdownContainer.querySelector('.custom-dropdown-btn');
        const dropdownItemsList = dropdownContainer.querySelector('.custom-dropdown-items');
        const dropdownItems = dropdownContainer.querySelectorAll('.custom-dropdown-items li');

        dropdownItems.forEach(item => {
            item.classList.remove('active');
            // Mark as active if it matches the size
            if (item.textContent.trim() === resetSize) {
                item.classList.add('active');
            }
        });

        // Update the dropdown button text.
        if (dropdownButton) {
            const displaySpan = dropdownButton.querySelector('span');
            if (displaySpan) {
                displaySpan.textContent = resetSize;
            }
        }

        if (dropdownItemsList) {
            dropdownItemsList.classList.remove('toggle');
        }
    }

    function resetEverything() {
        resetKonvaImage();

        resetOrientation();
        // sizeSelector.selectedIndex = 1;
        updateStageOrientation();
        resizeImage('21x15');
        resetSizeDropdown('21x15 (210 x 148 mm)');

        // Reset zoom
        resetZoom();
        resetFilters();
        resetMiroring();
        resetRotationAngel();

        resetBorderColor();
        resetFontFamily();

        originalWidth = null;
        originalHeight = null;
        imageWidth = null;
        imageHeight = null;
        imgAspectRatio = null;

        // Redraw the canvas
        layer.clear();
        stage.draw();
    }

    function checkUploadedImageOrientation() {
        if (currentUploadedImage.height > currentUploadedImage.width) {
            uploadedImageOrientation = 'portrait';
        } else if (currentUploadedImage.height === currentUploadedImage.width) {
            uploadedImageOrientation = 'quadratic';
        } else {
            uploadedImageOrientation = 'landscape';
        }

        return uploadedImageOrientation;
    }

    function setUploadInputText(text) {
        if (uploadImageLabelText) {
            uploadImageLabelText.textContent = text;
        }
    }

    function getSizeDimensionsBasedOnSelectedSize() {
        const matchingKey = Object.keys(sizeRequirements).find(key => key.startsWith(selectedSize));
        let { width, height } = sizeRequirements[matchingKey];

        return { width, height };
    }

    // Rotate button
    rotateButton.addEventListener('click', function() {
        rotateImage();
    });

    // Miror button
    mirrorButton.addEventListener('click', function() {
        toggleMirror();
    });

    // Zoom input
    zoomRangeInput.addEventListener('input', applyZoom);

    // Filters inputs
    brightnessInput.addEventListener('input', function() {
        currentBrightness = parseFloat(brightnessInput.value);
        applyFilters();
    });
    contrastInput.addEventListener('input', function() {
        currentContrast = parseFloat(contrastInput.value);
        applyFilters();
    });
    blurInput.addEventListener('input', function() {
        currentBlur = parseFloat(blurInput.value);
        applyFilters();
    });
    saturationInput.addEventListener('input', function() {
        currentSaturation = parseFloat(saturationInput.value);
        applyFilters();
    });
    hueInput.addEventListener('input', function() {
        currentHue = parseFloat(hueInput.value);
        applyFilters();
    });

    // Orientation toggle buttons
    orientationRadioButtons.forEach(radio => {
        radio.addEventListener('change', function() {
            resetZoom();
            resizeImage('21x15');
            resetSizeDropdown('21x15 (210 x 148 mm)');
            updateStageOrientation();
        });
    });

    resetFiltersButton.addEventListener('click', function() {
        resetFilters();
    })

    sizeSelector.addEventListener('click', function(event) {
        const sizeItem = event.target.closest('li');

        if (!sizeItem || sizeItem.classList.contains('disabled')) {
            return;
        }

        const selectedValue = sizeItem.textContent.trim();

        if (!selectedValue) return;

        if (!validateImageSizeCompatibility(selectedValue)) {
            sizeSelector.value = lastValidSize;
            if (!sizeSelector.value || sizeSelector.value === undefined || sizeSelector.value === null) {
                resetSizeDropdown('21x15 (210 x 148 mm)');
                return;
            }
            resetSizeDropdown(lastValidSize);
        } else {
            lastValidSize = selectedValue;
            resizeImage(lastValidSize);
        }
    });

    // Heading input
    headingInput.addEventListener('input', function() {
        // Add heading input validation 
        if (this.value.length > 25) {
            this.value = this.value.slice(0, 25);
        }

        updateImageSize();
    });

    // Sub heading input
    subheadingInput.addEventListener('input', function() {
        // Input field validation
        if (this.value.length > 50) {
            this.value = this.value.slice(0, 50);
        }

        updateImageSize();
    });

    fontRadioButtons.forEach(radio => {
        radio.addEventListener('change', (event) => {
            selectedFont = event.target.value;
            updateText();
        });
    });

    borderColorRadioButtons.forEach(radio => {
        radio.addEventListener('change', (event) => {
            const color = event.target.value;

            canvasContainer.style.borderColor = color;
            canvasContainer.style.backgroundColor = color;
            stage.getContainer().style.backgroundColor = color;

            currentTextColor = (color === '#000' || color === '#8A6240') ? 'white' : 'black';
            if (headingText.textContent.length) {
                headingText.style.color = currentTextColor;
            }
            if (subheadingText.textContent.length) {
                subheadingText.style.color = currentTextColor;
            }
        });
    });

    document.querySelectorAll('.filter-button').forEach(button => {
        button.addEventListener('click', function() {
            currentBrightness = parseInt(this.getAttribute('data-brightness'), 10);
            currentContrast = parseInt(this.getAttribute('data-contrast'), 10);
            currentHue = parseInt(this.getAttribute('data-hue'), 10);
            currentSaturation = parseInt(this.getAttribute('data-saturation'), 10);

            applySpecificFilterToPredefinedFiltersImage(currentBrightness, currentContrast, currentHue, currentSaturation);
        });
    });

    const controls = document.querySelectorAll('input, button, range, label');
    controls.forEach(control => {
        if (control.disabled) {
            // Mark initially disabled controls
            control.dataset.initiallyDisabled = 'true';
        }
    });

    function disableControls(enable) {
        const initiallyDisabledControls = document.querySelectorAll('[data-initially-disabled="true"]');
        initiallyDisabledControls.forEach(control => {
            control.disabled = enable;
        });
    }

    function minPixelsRequired(selectedSize) {
        const longestEdgeCm = parseInt(selectedSize.split('x')[0]);
        if (longestEdgeCm <= 60) return 800;
        if (longestEdgeCm <= 80) return 1000;
        return 1200;
    }

    function setCursor(type) {
        const cursorType = type === 'grab' ? 'grab' : 'default';
        canvasInnerContainer.style.cursor = cursorType;
    }

    function showAlert(headerText, messageText, reset) {
        if (konvaImg && reset) {
            imageUploadInput.value = '';
            konvaImg.destroy();
            konvaImg = null;
            currentUploadedImage = null;
            layer.draw();
        }
        $('#custom-image-warning-modal .modal-header h3').text(headerText);
        $('#custom-image-warning-modal .modal-body p').text(messageText);
        $('#custom-image-warning-modal').modal('show');
    }

    // Add background color to custom range inputs
    rangeSliderInput.forEach((rangeInput) => {
        const inputMinValue = parseFloat(rangeInput.min) || 0;
        const inputMaxValue = parseFloat(rangeInput.max) || 100;

        function updateTrackFill() {
            const val = parseFloat(rangeInput.value);
            const percent = ((val - inputMinValue) / (inputMaxValue - inputMinValue)) * 100;
            rangeInput.style.setProperty('--range-percent', `${percent}%`);
        }

        rangeInput.addEventListener('input', updateTrackFill);
        updateTrackFill();
    });

    function setRangeInputTrackFill(input, resetValue) {
        // If no reset value is provided, fallback to input min value
        if (resetValue === undefined || resetValue === null) {
            resetValue = input.min;
        }
        // Otherwise set the reset value
        input.value = resetValue;

        const inputMinValue = parseFloat(input.min) || 0;
        const inputMaxValue = parseFloat(input.max) || 100;
        const inputValue = parseFloat(input.value);

        // Set the percent for the input track
        const percent = ((inputValue - inputMinValue) / (inputMaxValue - inputMinValue)) * 100;

        input.style.setProperty('--range-percent', `${percent}%`);
    }

    function previewFinalCanvasImage() {
        const dataURL = stage.toDataURL({
            pixelRatio: 2,
            x: 0,
            y: 0,
            width: stage.width(),
            height: stage.height(),
        });

        // Create a new image element
        const previewImg = new Image();
        previewImg.src = dataURL;
        previewImg.style.maxWidth = stage.width() + 'px';
        previewImg.style.maxWidth = stage.height() + 'px';
        previewImg.style.marginTop = '1rem';
        previewImg.style.marginBottom = '5rem';

        // Append image for display
        document.body.appendChild(previewImg);
    }

    function getVisibleImageCoordinates() {
        if (!konvaImg || !currentUploadedImage) return null;

        const scaleX = konvaImg.scaleX();
        const scaleY = konvaImg.scaleY();

        const absScaleX = Math.abs(scaleX);
        const absScaleY = Math.abs(scaleY);

        // Konva stage width & height
        const stageWidth = stage.width();
        const stageHeight = stage.height();

        // Image position on the canvas
        const imgX = konvaImg.x();
        const imgY = konvaImg.y();

        // The image is drawn at some size on the canvas
        const displayWidth = konvaImg.width() * absScaleX;
        const displayHeight = konvaImg.height() * absScaleY;

        // Calculate what portion of the image is visible inside the canvas
        const visibleLeft = Math.max(0, -imgX);
        const visibleTop = Math.max(0, -imgY);
        const visibleRight = Math.min(displayWidth, stageWidth - imgX);
        const visibleBottom = Math.min(displayHeight, stageHeight - imgY);

        const cropX = (visibleLeft / displayWidth) * currentUploadedImage.width;
        const cropY = (visibleTop / displayHeight) * currentUploadedImage.height;
        const cropWidth = ((visibleRight - visibleLeft) / displayWidth) * currentUploadedImage.width;
        const cropHeight = ((visibleBottom - visibleTop) / displayHeight) * currentUploadedImage.height;

        return {
            x: Math.round(cropX),
            y: Math.round(cropY),
            width: Math.round(cropWidth),
            height: Math.round(cropHeight)
        };
    }

    function submitData() {
        if (!konvaImg) {
            return;
        }

        const xPos = konvaImg.x();
        const yPos = konvaImg.y();
        const imgWidth = konvaImg.width() * konvaImg.scaleX();
        const imgHeight = konvaImg.height() * konvaImg.scaleY();

        // Calculate distances from all edges
        const leftPos = xPos;
        const topPos = yPos;
        const rightPos = stage.width() - (xPos + imgWidth);
        const bottomPos = stage.height() - (yPos + imgHeight);

        // Gather data
        const imageData = {
            image_url: konvaImg.image().src,

            visible_image_coordinates: {
                left_position: (leftPos / konvaImg.width()) * currentUploadedImage.width,
                right_position: (rightPos / konvaImg.width()) * currentUploadedImage.width,
                top_position: (topPos / konvaImg.height()) * currentUploadedImage.height,
                bottom_position: (bottomPos / konvaImg.height()) * currentUploadedImage.height
            },

            alternative_visible_coordinates: getVisibleImageCoordinates(),

            general: {
                selected_size: selectedSize,
                orientation: selectedOrientation,
                is_mirrored: isMirrored,
                rotation_degree: rotationAngle,
                zoom_level: parseFloat(zoomRangeInput.value),
                frame_border_color: canvasContainer.style.borderColor
            },

            filters: {
                brightness: currentBrightness,
                contrast: currentContrast,
                blur: currentBlur,
                saturation: currentSaturation,
                hue: currentHue
            },

            text: {
                heading: headingInput.value,
                sub_heading: subheadingInput.value,
                selected_font: selectedFont,
                heading_font_size: headingText.style.fontSize,
                sub_heading_font_size: subheadingText.style.fontSize,
            },
        };

        // Log the data
        console.log("Current Image Data:", imageData);
    };

    submitButton.addEventListener('click', async function() {
        submitData();
        // previewFinalCanvasImage();
        renderFinalOriginalImageWithEdits();
    });

    function base64ToBlob(base64, mimeType = 'image/png') {
        // split the code and decodes it into binary text
        const byteString = atob(base64.split(',')[1]);
        const arrayContainer = new ArrayBuffer(byteString.length);

        // create a new Uint8Array to hold the binary data
        // and fill it with the decoded byteString
        const arrayView = new Uint8Array(arrayContainer);

        // Loop through the byteString and fill the arrayView with the binary data
        for (let i = 0; i < byteString.length; i++) {
            arrayView[i] = byteString.charCodeAt(i);
        }

        return new Blob([arrayContainer], { type: mimeType });
    }

    function renderFinalOriginalImageWithEdits(callback) {
        if (!originalImageFile || !konvaImg) return;

        window.showLoadingSpinner('custom-image-upload-loader', true);

        const reader = new FileReader();
        reader.onload = function(e) {
            const highResImg = new Image();

            highResImg.onload = () => {
                konvaImg.image(highResImg);
                konvaImg.clearCache();
                konvaImg.cache({ pixelRatio: 6 });

                layer.batchDraw();

                // Export full-res version using stage.toDataURL()
                const dataURL = stage.toDataURL({
                    pixelRatio: 6,
                    mimeType: 'image/png',
                    quality: 1,
                });

                const finalBlobImage = base64ToBlob(dataURL, 'image/png');

                // Optional: display preview using Blob
                const blobUrl = URL.createObjectURL(finalBlobImage);
                const previewImg = new Image();
                previewImg.onload = () => {
                    previewImg.style.maxWidth = stage.width() + 'px';
                    previewImg.style.maxHeight = stage.height() + 'px';
                    previewImg.style.marginTop = '1rem';
                    previewImg.style.marginBottom = '5rem';
                    document.body.appendChild(previewImg);

                    console.log(`Blob created:`, finalBlobImage, (finalBlobImage.size / (1024 * 1024)).toFixed(2) + ' MB');

                    // Switch back to the low quality image for preview & editing
                    konvaImg.image(currentUploadedImage);
                    konvaImg.cache({ pixelRatio: 3 });
                    layer.draw();

                    window.showLoadingSpinner('custom-image-upload-loader', false, 500);
                    if (callback) callback();
                };

                previewImg.src = blobUrl;
            };
            highResImg.src = e.target.result;
        };
        reader.readAsDataURL(originalImageFile);
    }

    // Splide init
    const filterSplide = new Splide('#filters-slider-container', {
        type: 'slide',
        perPage: 4.5,
        perMove: 1,
        gap: '0.813rem',
        rewind: true,
        pagination: false,
        arrows: false,
        breakpoints: {
            1300: {
                perPage: 3.5
            },
            1020: {
                perPage: 4.5,
            },
            1019: {
                perPage: 4.5
            },
            768: {
                perPage: 3.5
            },
            474: {
                perPage: 2.5
            }
        }
    });

    filterSplide.mount();

    document.getElementById('prev-filters-slide').addEventListener('click', () => {
        filterSplide.go('<');
    });

    document.getElementById('next-filters-slide').addEventListener('click', () => {
        filterSplide.go('>');
    });
});